<template>
  <nav id="platform-admin-menu">
    <div class="brand" @click="$router.push({ name: 'platform-admin.dashboard' })">
      <img :src="fluxooLogo" alt="Logo fluxoo doc">
      <span>Painel interno</span>
    </div>
    <div class="links">
      <button :class="{ active: $route.name === 'platform-admin.dashboard' }" @click="$router.push({ name: 'platform-admin.dashboard' })">Dashboard</button>
      <button :class="{ active: $route.name === 'platform-admin.tenants.index' || $route.name === 'platform-admin.tenants.edit' }" @click="$router.push({ name: 'platform-admin.tenants.index' })">Tenants</button>
    </div>
    <div class="user">
      <span>{{ platformAdmin.name }}</span>
      <button title="Desconectar" @click="logout">
        <figure>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M17.4417 14.62L20.0017 12.06L17.4417 9.5M9.76172 12.06H19.9317M11.7617 20C7.34172 20 3.76172 17 3.76172 12C3.76172 7 7.34172 4 11.7617 4" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </figure>
      </button>
    </div>
  </nav>
  <Loader v-if="isLoggingOut" :zIndex="10" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAxios } from '@/api/axios'
import router from '@/router'
import { platformAdmin } from '@/global/states/PlatformAdminState'
import Loader from '@/components/loader/Loader.vue'
import fluxooLogo from '@/assets/images/fluxoo-doc-logo.png'

const axios = useAxios()
const isLoggingOut = ref(false)

const logout = () => {
  isLoggingOut.value = true

  axios.post('/api/platform-admin/logout').then(() => {
    router.push({ name: 'platform-admin.login' })
  }).finally(() => isLoggingOut.value = false)
}
</script>

<style lang="scss">
  #platform-admin-menu{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 24px;
    padding: 0 32px;
    height: 80px;
    min-height: 80px;
    background: #FFF;
    box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    position: sticky;
    top: 0;
    z-index: 5;
    .brand{
      display: flex;
      align-items: center;
      column-gap: 12px;
      cursor: pointer;
      img{
        width: 130px;
        min-width: 74px;
        height: 39px;
      }
      span{
        color: #6F6F6F;
        font-family: 'Inter', sans-serif;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        border-left: 1px solid #D3D3D3;
        padding: 0 0 0 12px;
      }
    }
    .links{
      display: flex;
      align-items: center;
      column-gap: 8px;
      button{
        height: 44px;
        padding: 0 20px;
        border-radius: 30px;
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        transition: background .2s, color .2s;
        cursor: pointer;
        &:hover{
          background: $fluxoo-menu-primary-color-hover;
        }
        &.active{
          background: $fluxoo-primary-color;
          color: #FFF;
        }
      }
    }
    .user{
      display: flex;
      align-items: center;
      column-gap: 16px;
      span{
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        white-space: nowrap;
      }
      button{
        width: 40px;
        min-width: 40px;
        height: 40px;
        min-height: 40px;
        border-radius: 50%;
        background: transparent;
        transition: background .2s;
        cursor: pointer;
        &:hover{
          background: #F5F5F5;
          svg{
            stroke: $fluxoo-primary-color;
          }
        }
        figure{
          width: 100%;
          height: 100%;
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            width: 22px;
            min-width: 22px;
            height: 22px;
            min-height: 22px;
            stroke: #090909;
            transition: stroke .2s;
          }
        }
      }
    }
  }

  @media(max-width: 700px){
    #platform-admin-menu{
      flex-wrap: wrap;
      height: unset;
      row-gap: 12px;
      padding: 16px 20px;
      .brand{
        span{
          display: none;
        }
      }
      .user{
        span{
          display: none;
        }
      }
    }
  }
</style>
